/**
 * Notifications store module
 */

import {apiNotification} from '../api'

const state = {
  list: [],
}

const getters = {
  list(state) {
    return state.list
  },
}

const mutations = {
  setNotifications(state, data) {
    state.list = data
  },
  
  delete(state, index){
    state.list.splice(index, 1)
  },
  
  setViewedAll(state){
    state.list.map( item => { item.is_viewed = 1})
  },
  
  add(state, data){
    state.list.unshift(data)
  }
}

const actions = {
  /**
   *  Загрузка уведомлений
   */
  loadNotifications({ rootState, commit }) {
    const profile = rootState.app.account.profile
    let data = {
      email: profile.email,
      phone: profile.phone
    }
    return new Promise((resolve, reject) => {
      apiNotification.list(data).then( response => {
        commit('setNotifications', response)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  /**
   * Удаление уведомления
   * index: Integer,
   */
  delete ({ commit, state }, index) {
    return new Promise( (resolve, reject) => {
      let id = state.list[index].sending_id
      apiNotification.delete(id).then( response => {
        commit('delete', index)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  view({commit}, id){
    return new Promise( (resolve, reject) => {
      apiNotification.update(id).then( response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  viewAll({commit}){
    return new Promise( (resolve, reject) => {
      apiNotification.viewedAll().then( response => {
        commit('setViewedAll')
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/apps/notifications/store/index.js